import type {Component, Editor} from 'grapesjs';
import {EMAIL_MAKER_BUTTON_PRESETS, EMAIL_MAKER_PROPS} from '@EmailMakerReact/email-maker-react.constants';
import {setComponentStyle} from '@EmailMakerReact/lib/email-maker-component-style-library';
import type {PresetOption, PresetSelectorDescriptor} from './preset-selector-control.types';

export const buttonPresetDescriptor: PresetSelectorDescriptor = {
  property: EMAIL_MAKER_PROPS.COMPONENT_PRESET,
  defaultPresetId: 0,
  options: [
    {id: 1, compValues: [EMAIL_MAKER_BUTTON_PRESETS[1]], classUnit: 'px'},
    {id: 2, compValues: [EMAIL_MAKER_BUTTON_PRESETS[2]], classUnit: 'px'},
    {id: 3, compValues: [EMAIL_MAKER_BUTTON_PRESETS[3]], classUnit: 'px'},
    {id: 4, compValues: [EMAIL_MAKER_BUTTON_PRESETS[4]], classUnit: 'px'},
  ] satisfies readonly PresetOption[],
  onPresetSelect(component: Component, preset: PresetOption, editor: Editor): void {
    const radius = `${preset.compValues[0]}${preset.classUnit}`;
    setComponentStyle(editor, {property: 'border-radius', value: radius, component});
  },
};
